<div class="component-editor feature-comparison-builder">
  <div class="stepper">
    <div class="stepper-progress">
      <div class="stepper-progress-bar" [style.width.%]="(currentStep / steps.length) * 100"></div>
    </div>

    <div class="stepper-nav stepper-nav--feature">
      <div
        *ngFor="let step of steps"
        class="stepper-chip"
        [class.is-active]="isCurrentStep(step.index)"
        [class.is-complete]="isStepComplete(step.index)"
        (click)="setStep(step.index)"
        style="cursor: pointer;">
        <span class="stepper-index">{{ step.index }}</span>
        <div>
          <div class="stepper-label">{{ step.labelKey | translate }}</div>
          <small>{{ step.descriptionKey | translate }}</small>
        </div>
      </div>
    </div>
  </div>

  <section class="step-card" *ngIf="currentStep === 1">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'FEATURE_COMPARISON_GENERAL_DATA' | translate }}</h4>
        <p class="step-card-copy">{{ 'FEATURE_COMPARISON_GENERAL_DATA_COPY' | translate }}</p>
      </div>
    </div>

    <div class="section-grid">
      <div class="section-block">
        <div class="field-head" *ngIf="isEnglishMode; else generalTitleLabel">
          <label class="section-label">{{ 'FEATURE_COMPARISON_TITLE' | translate }}</label>
          <div class="translation-switch-control">
            <span class="translation-mode-badge" [class.is-manual]="isGeneralFieldManual('title')">
              {{ getTranslationModeLabelKey(isGeneralFieldManual('title')) | translate }}
            </span>
            <label class="switch">
              <input type="checkbox" [checked]="isGeneralFieldManual('title')" (change)="toggleGeneralField('title', $any($event.target).checked)" />
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <ng-template #generalTitleLabel>
          <label class="section-label">{{ 'FEATURE_COMPARISON_TITLE' | translate }}</label>
        </ng-template>
        <input
          class="form-control"
          type="text"
          [ngModel]="getGeneralFieldValue('title')"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setGeneralFieldValue('title', $event)"
          [disabled]="isEnglishMode && !isGeneralFieldManual('title')"
          maxlength="120" />
        <div class="error-text" *ngIf="submitAttempted && hasPathError('title')">{{ getPathError('title') }}</div>
      </div>

      <div class="section-block">
        <div class="field-head" *ngIf="isEnglishMode; else generalSubtitleLabel">
          <label class="section-label">{{ 'FEATURE_COMPARISON_SUBTITLE' | translate }}</label>
          <div class="translation-switch-control">
            <span class="translation-mode-badge" [class.is-manual]="isGeneralFieldManual('subtitle')">
              {{ getTranslationModeLabelKey(isGeneralFieldManual('subtitle')) | translate }}
            </span>
            <label class="switch">
              <input type="checkbox" [checked]="isGeneralFieldManual('subtitle')" (change)="toggleGeneralField('subtitle', $any($event.target).checked)" />
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <ng-template #generalSubtitleLabel>
          <label class="section-label">{{ 'FEATURE_COMPARISON_SUBTITLE' | translate }}</label>
        </ng-template>
        <input
          class="form-control"
          type="text"
          [ngModel]="getGeneralFieldValue('subtitle')"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setGeneralFieldValue('subtitle', $event)"
          [disabled]="isEnglishMode && !isGeneralFieldManual('subtitle')"
          maxlength="180" />
      </div>

      <div class="section-block">
        <div class="field-head" *ngIf="isEnglishMode; else generalFeatureColumnLabel">
          <label class="section-label">{{ 'FEATURE_COMPARISON_FEATURE_COLUMN_TITLE' | translate }}</label>
          <div class="translation-switch-control">
            <span class="translation-mode-badge" [class.is-manual]="isGeneralFieldManual('featureColumnTitle')">
              {{ getTranslationModeLabelKey(isGeneralFieldManual('featureColumnTitle')) | translate }}
            </span>
            <label class="switch">
              <input type="checkbox" [checked]="isGeneralFieldManual('featureColumnTitle')" (change)="toggleGeneralField('featureColumnTitle', $any($event.target).checked)" />
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <ng-template #generalFeatureColumnLabel>
          <label class="section-label">{{ 'FEATURE_COMPARISON_FEATURE_COLUMN_TITLE' | translate }}</label>
        </ng-template>
        <input
          class="form-control"
          type="text"
          [ngModel]="getGeneralFieldValue('featureColumnTitle')"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setGeneralFieldValue('featureColumnTitle', $event)"
          [disabled]="isEnglishMode && !isGeneralFieldManual('featureColumnTitle')"
          maxlength="120" />
        <div class="error-text" *ngIf="submitAttempted && hasPathError('featureColumnTitle')">{{ getPathError('featureColumnTitle') }}</div>
      </div>
    </div>

    <div class="section-grid single-column">
      <div class="section-block">
        <div class="switch-title-container">
          <div>
            <label class="section-label">{{ 'FEATURE_COMPARISON_PRICE_MODE' | translate }}</label>
            <p class="helper-text">{{ 'FEATURE_COMPARISON_PRICE_MODE_HELPER' | translate }}</p>
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block nested-block">
            <label class="section-label">{{ 'FEATURE_COMPARISON_PRICE_DISPLAY' | translate }}</label>
            <select
              class="form-select"
              [ngModel]="workingConfig.billing.priceDisplayMode"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="setPriceDisplayMode($event)"
              [disabled]="isEnglishMode">
              <option value="monthly">{{ 'FEATURE_COMPARISON_MONTHLY_ONLY' | translate }}</option>
              <option value="annual">{{ 'FEATURE_COMPARISON_ANNUAL_ONLY' | translate }}</option>
              <option value="toggle">{{ 'FEATURE_COMPARISON_MONTHLY_ANNUAL_TOGGLE' | translate }}</option>
            </select>
            <div class="error-text" *ngIf="submitAttempted && hasPathError('billing.priceDisplayMode')">{{ getPathError('billing.priceDisplayMode') }}</div>
          </div>

          <div class="section-block nested-block">
            <div class="field-head" *ngIf="isEnglishMode; else monthlyLabelLabel">
              <label class="section-label">{{ 'FEATURE_COMPARISON_MONTHLY_LABEL' | translate }}</label>
              <div class="translation-switch-control">
                <span class="translation-mode-badge" [class.is-manual]="isBillingFieldManual('monthlyLabel')">
                  {{ getTranslationModeLabelKey(isBillingFieldManual('monthlyLabel')) | translate }}
                </span>
                <label class="switch">
                  <input type="checkbox" [checked]="isBillingFieldManual('monthlyLabel')" (change)="toggleBillingField('monthlyLabel', $any($event.target).checked)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <ng-template #monthlyLabelLabel>
              <label class="section-label">{{ 'FEATURE_COMPARISON_MONTHLY_LABEL' | translate }}</label>
            </ng-template>
            <input
              class="form-control"
              type="text"
              [ngModel]="getBillingFieldValue('monthlyLabel')"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="setBillingFieldValue('monthlyLabel', $event)"
              [disabled]="isEnglishMode && !isBillingFieldManual('monthlyLabel')"
              maxlength="60" />
            <div class="error-text" *ngIf="submitAttempted && hasPathError('billing.monthlyLabel')">{{ getPathError('billing.monthlyLabel') }}</div>
          </div>

          <div class="section-block nested-block">
            <div class="field-head" *ngIf="isEnglishMode; else annualLabelLabel">
              <label class="section-label">{{ 'FEATURE_COMPARISON_ANNUAL_LABEL' | translate }}</label>
              <div class="translation-switch-control">
                <span class="translation-mode-badge" [class.is-manual]="isBillingFieldManual('annualLabel')">
                  {{ getTranslationModeLabelKey(isBillingFieldManual('annualLabel')) | translate }}
                </span>
                <label class="switch">
                  <input type="checkbox" [checked]="isBillingFieldManual('annualLabel')" (change)="toggleBillingField('annualLabel', $any($event.target).checked)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <ng-template #annualLabelLabel>
              <label class="section-label">{{ 'FEATURE_COMPARISON_ANNUAL_LABEL' | translate }}</label>
            </ng-template>
            <input
              class="form-control"
              type="text"
              [ngModel]="getBillingFieldValue('annualLabel')"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="setBillingFieldValue('annualLabel', $event)"
              [disabled]="isEnglishMode && !isBillingFieldManual('annualLabel')"
              maxlength="60" />
            <div class="error-text" *ngIf="submitAttempted && hasPathError('billing.annualLabel')">{{ getPathError('billing.annualLabel') }}</div>
          </div>

          <div class="section-block nested-block" *ngIf="normalizedConfig.billing.priceDisplayMode === 'toggle'">
            <label class="section-label">{{ 'FEATURE_COMPARISON_DEFAULT_MODE' | translate }}</label>
            <select
              class="form-select"
              [ngModel]="workingConfig.billing.defaultMode"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="setBillingDefaultMode($event)"
              [disabled]="isEnglishMode">
              <option value="monthly">{{ 'FEATURE_COMPARISON_MONTHLY' | translate }}</option>
              <option value="annual">{{ 'FEATURE_COMPARISON_ANNUAL' | translate }}</option>
            </select>
            <div class="error-text" *ngIf="submitAttempted && hasPathError('billing.defaultMode')">{{ getPathError('billing.defaultMode') }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="step-card" *ngIf="currentStep === 2">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'FEATURE_COMPARISON_PLANS' | translate }}</h4>
        <p class="step-card-copy">{{ 'FEATURE_COMPARISON_PLANS_COPY' | translate }}</p>
      </div>
      <button type="button" class="btn-step btn-secondary btn-inline" (click)="addPlan()" *ngIf="!isEnglishMode">{{ 'FEATURE_COMPARISON_ADD_PLAN' | translate }}</button>
    </div>

    <div class="error-text section-error" *ngIf="submitAttempted && hasPathError('plans')">{{ getPathError('plans') }}</div>
    <div class="error-text section-error" *ngIf="submitAttempted && hasPathError('plans.featured')">{{ getPathError('plans.featured') }}</div>

    <div class="column-card-list">
      <article class="step-card column-card" *ngFor="let plan of plans; let index = index; trackBy: trackById">
        <div class="item-panel-header">
          <div>
            <h5 class="item-panel-title">{{ 'FEATURE_COMPARISON_PLAN_NUMBER' | translate:{ number: index + 1 } }}</h5>
            <p class="helper-text">{{ 'FEATURE_COMPARISON_ORDER_NUMBER' | translate:{ order: plan.order } }}</p>
          </div>

          <div class="action-group" *ngIf="!isEnglishMode">
            <button type="button" class="delete-button" (click)="removePlan(plan.id)">x</button>
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block nested-block">
            <div class="field-head" *ngIf="isEnglishMode; else planNameLabel">
              <label class="section-label">{{ 'FEATURE_COMPARISON_NAME' | translate }}</label>
              <div class="translation-switch-control">
                <span class="translation-mode-badge" [class.is-manual]="isPlanFieldManual(plan.id, 'name')">
                  {{ getTranslationModeLabelKey(isPlanFieldManual(plan.id, 'name')) | translate }}
                </span>
                <label class="switch">
                  <input type="checkbox" [checked]="isPlanFieldManual(plan.id, 'name')" (change)="togglePlanField(plan.id, 'name', $any($event.target).checked)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <ng-template #planNameLabel>
              <label class="section-label">{{ 'FEATURE_COMPARISON_NAME' | translate }}</label>
            </ng-template>
            <input
              class="form-control"
              type="text"
              [ngModel]="isEnglishMode ? getPlanTranslatedField(plan.id, 'name') : plan.name"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="isEnglishMode ? setPlanTranslatedField(plan.id, 'name', $event) : setBasePlanField(plan.id, 'name', $event)"
              [disabled]="isEnglishMode && !isPlanFieldManual(plan.id, 'name')"
              maxlength="120" />
            <div class="error-text" *ngIf="submitAttempted && hasPathError('plan:' + plan.id + ':name')">{{ getPathError('plan:' + plan.id + ':name') }}</div>
          </div>

          <div class="section-block nested-block">
            <label class="section-label">{{ 'FEATURE_COMPARISON_CURRENCY' | translate }}</label>
            <input class="form-control" type="text" [ngModel]="plan.currency" [ngModelOptions]="{ standalone: true }" (ngModelChange)="setBasePlanField(plan.id, 'currency', $event)" [disabled]="isEnglishMode" maxlength="10" placeholder="$" />
          </div>
        </div>

        <div class="section-grid single-column">
          <div class="section-block nested-block">
            <div class="field-head" *ngIf="isEnglishMode; else planDescriptionLabel">
              <label class="section-label">{{ 'FEATURE_COMPARISON_DESCRIPTION' | translate }}</label>
              <div class="translation-switch-control">
                <span class="translation-mode-badge" [class.is-manual]="isPlanFieldManual(plan.id, 'description')">
                  {{ getTranslationModeLabelKey(isPlanFieldManual(plan.id, 'description')) | translate }}
                </span>
                <label class="switch">
                  <input type="checkbox" [checked]="isPlanFieldManual(plan.id, 'description')" (change)="togglePlanField(plan.id, 'description', $any($event.target).checked)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <ng-template #planDescriptionLabel>
              <label class="section-label">{{ 'FEATURE_COMPARISON_DESCRIPTION' | translate }}</label>
            </ng-template>
            <textarea
              class="form-control feature-textarea"
              rows="3"
              [ngModel]="isEnglishMode ? getPlanTranslatedField(plan.id, 'description') : plan.description"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="isEnglishMode ? setPlanTranslatedField(plan.id, 'description', $event) : setBasePlanField(plan.id, 'description', $event)"
              [disabled]="isEnglishMode && !isPlanFieldManual(plan.id, 'description')"></textarea>
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block nested-block">
            <label class="section-label">{{ 'FEATURE_COMPARISON_MONTHLY_PRICE' | translate }}</label>
            <input class="form-control" type="text" [ngModel]="plan.monthlyPrice" [ngModelOptions]="{ standalone: true }" (ngModelChange)="setBasePlanField(plan.id, 'monthlyPrice', $event)" [disabled]="isEnglishMode" maxlength="40" />
          </div>

          <div class="section-block nested-block">
            <label class="section-label">{{ 'FEATURE_COMPARISON_ANNUAL_PRICE' | translate }}</label>
            <input class="form-control" type="text" [ngModel]="plan.annualPrice" [ngModelOptions]="{ standalone: true }" (ngModelChange)="setBasePlanField(plan.id, 'annualPrice', $event)" [disabled]="isEnglishMode" maxlength="40" />
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block nested-block">
            <div class="field-head" *ngIf="isEnglishMode; else planPriceSuffixLabel">
              <label class="section-label">{{ 'FEATURE_COMPARISON_PRICE_SUFFIX' | translate }}</label>
              <div class="translation-switch-control">
                <span class="translation-mode-badge" [class.is-manual]="isPlanFieldManual(plan.id, 'priceSuffix')">
                  {{ getTranslationModeLabelKey(isPlanFieldManual(plan.id, 'priceSuffix')) | translate }}
                </span>
                <label class="switch">
                  <input type="checkbox" [checked]="isPlanFieldManual(plan.id, 'priceSuffix')" (change)="togglePlanField(plan.id, 'priceSuffix', $any($event.target).checked)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <ng-template #planPriceSuffixLabel>
              <label class="section-label">{{ 'FEATURE_COMPARISON_PRICE_SUFFIX' | translate }}</label>
            </ng-template>
            <input
              class="form-control"
              type="text"
              [ngModel]="isEnglishMode ? getPlanTranslatedField(plan.id, 'priceSuffix') : plan.priceSuffix"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="isEnglishMode ? setPlanTranslatedField(plan.id, 'priceSuffix', $event) : setBasePlanField(plan.id, 'priceSuffix', $event)"
              [disabled]="isEnglishMode && !isPlanFieldManual(plan.id, 'priceSuffix')"
              maxlength="80"
              placeholder="{{ 'FEATURE_COMPARISON_PRICE_SUFFIX_PLACEHOLDER' | translate }}" />
          </div>

          <div class="section-block nested-block">
            <div class="field-head" *ngIf="isEnglishMode; else planRedirectLabelLabel">
              <label class="section-label">{{ 'FEATURE_COMPARISON_REDIRECT_LABEL' | translate }}</label>
              <div class="translation-switch-control">
                <span class="translation-mode-badge" [class.is-manual]="isPlanFieldManual(plan.id, 'redirectLabel')">
                  {{ getTranslationModeLabelKey(isPlanFieldManual(plan.id, 'redirectLabel')) | translate }}
                </span>
                <label class="switch">
                  <input type="checkbox" [checked]="isPlanFieldManual(plan.id, 'redirectLabel')" (change)="togglePlanField(plan.id, 'redirectLabel', $any($event.target).checked)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <ng-template #planRedirectLabelLabel>
              <label class="section-label">{{ 'FEATURE_COMPARISON_REDIRECT_LABEL' | translate }}</label>
            </ng-template>
            <input
              class="form-control"
              type="text"
              [ngModel]="isEnglishMode ? getPlanTranslatedField(plan.id, 'redirectLabel') : plan.redirectLabel"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="isEnglishMode ? setPlanTranslatedField(plan.id, 'redirectLabel', $event) : setBasePlanField(plan.id, 'redirectLabel', $event)"
              [disabled]="isEnglishMode && !isPlanFieldManual(plan.id, 'redirectLabel')"
              maxlength="120"
              placeholder="{{ 'FEATURE_COMPARISON_REDIRECT_LABEL_PLACEHOLDER' | translate }}" />
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block nested-block">
            <label class="section-label">{{ 'FEATURE_COMPARISON_REDIRECT_URL' | translate }}</label>
            <input class="form-control" type="text" [ngModel]="plan.redirectUrl" [ngModelOptions]="{ standalone: true }" (ngModelChange)="setBasePlanField(plan.id, 'redirectUrl', $event)" [disabled]="isEnglishMode" maxlength="300" placeholder="{{ 'FEATURE_COMPARISON_REDIRECT_URL_PLACEHOLDER' | translate }}" />
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block nested-block">
            <label class="option-chip option-chip--checkbox">
              <input type="checkbox" [ngModel]="plan.featured" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFeaturedChange(plan.id, $event)" [disabled]="isEnglishMode" />
              {{ 'FEATURE_COMPARISON_MARK_FEATURED' | translate }}
            </label>
            <p class="helper-text">{{ 'FEATURE_COMPARISON_FEATURED_HELPER' | translate }}</p>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="step-card" *ngIf="currentStep === 3">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'FEATURE_COMPARISON_INCLUDED_FEATURES' | translate }}</h4>
        <p class="step-card-copy">{{ 'FEATURE_COMPARISON_INCLUDED_FEATURES_COPY' | translate }}</p>
      </div>
      <button type="button" class="btn-step btn-secondary btn-inline" (click)="addFeature()" *ngIf="!isEnglishMode">{{ 'FEATURE_COMPARISON_ADD_FEATURE' | translate }}</button>
    </div>

    <div class="error-text section-error" *ngIf="submitAttempted && hasPathError('features')">{{ getPathError('features') }}</div>

    <div class="matrix-wrapper">
      <table class="matrix-table">
        <thead>
          <tr>
            <th>{{ displayedFeatureColumnTitle }}</th>
            <th *ngFor="let plan of plans; trackBy: trackById">{{ plan.name || ('FEATURE_COMPARISON_UNNAMED' | translate) }}</th>
            <th class="matrix-actions-header" *ngIf="!isEnglishMode">{{ 'FEATURE_COMPARISON_ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let feature of features; trackBy: trackById">
            <td class="matrix-feature-cell">
              <div class="field-head" *ngIf="isEnglishMode">
                <label class="section-label">{{ 'FEATURE_COMPARISON_FEATURE_DETAIL' | translate }}</label>
                <div class="translation-switch-control">
                  <span class="translation-mode-badge" [class.is-manual]="isFeatureFieldManual(feature.id)">
                    {{ getTranslationModeLabelKey(isFeatureFieldManual(feature.id)) | translate }}
                  </span>
                  <label class="switch">
                    <input type="checkbox" [checked]="isFeatureFieldManual(feature.id)" (change)="toggleFeatureField(feature.id, $any($event.target).checked)" />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <input
                class="form-control"
                type="text"
                [ngModel]="isEnglishMode ? getFeatureTranslatedField(feature.id) : feature.label"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="isEnglishMode ? setFeatureTranslatedField(feature.id, $event) : setBaseFeatureLabel(feature.id, $event)"
                [disabled]="isEnglishMode && !isFeatureFieldManual(feature.id)"
                maxlength="160"
                placeholder="{{ 'FEATURE_COMPARISON_FEATURE_NAME_PLACEHOLDER' | translate }}" />
              <div class="error-text" *ngIf="submitAttempted && hasPathError('feature:' + feature.id + ':label')">{{ getPathError('feature:' + feature.id + ':label') }}</div>
            </td>

            <td *ngFor="let plan of plans; trackBy: trackById" class="matrix-value-cell">
              <label class="checkbox-cell">
                <input
                  type="checkbox"
                  [ngModel]="isFeatureIncluded(feature.id, plan.id)"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="toggleFeatureIncluded(feature.id, plan.id, $event)"
                  [disabled]="isEnglishMode" />
                <span>{{ 'FEATURE_COMPARISON_INCLUDED' | translate }}</span>
              </label>
            </td>

            <td class="matrix-actions-cell" *ngIf="!isEnglishMode">
              <div class="action-group action-group--column">
                <button type="button" class="delete-button" (click)="removeFeature(feature.id)">x</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="step-card" *ngIf="currentStep === 4">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'FEATURE_COMPARISON_PREVIEW' | translate }}</h4>
        <p class="step-card-copy">{{ 'FEATURE_COMPARISON_PREVIEW_COPY' | translate }}</p>
      </div>
    </div>

    <div class="preview-shell">
      <app-feature-comparison-renderer
        [config]="normalizedConfig"
        [translatedContent]="isEnglishMode ? normalizedTranslation : null"
        [language]="isEnglishMode ? 'en' : 'es'">
      </app-feature-comparison-renderer>
    </div>

    <div class="section-block is-muted" *ngIf="previewIssues.length > 0">
      <label class="section-label">{{ 'FEATURE_COMPARISON_ERRORS_BEFORE_SAVE' | translate }}</label>
      <ul class="error-summary">
        <li *ngFor="let issue of previewIssues">{{ issue.message }}</li>
      </ul>
    </div>

    <div class="section-block is-muted" *ngIf="previewIssues.length === 0">
      <p class="helper-text">{{ 'FEATURE_COMPARISON_READY_TO_SAVE' | translate }}</p>
    </div>
  </section>

  <div class="step-actions">
    <button type="button" class="btn-step btn-secondary" (click)="prevStep()" [disabled]="currentStep === 1">{{ 'FEATURE_COMPARISON_PREVIOUS' | translate }}</button>
    <button type="button" class="btn-step btn-primary" (click)="nextStep()" *ngIf="currentStep < steps.length">{{ 'FEATURE_COMPARISON_NEXT' | translate }}</button>
  </div>
</div>
